import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';

import { ProgressSpinner } from 'primereact/progressspinner';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './Actuals.css'

import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../../services/api';
import { FaSyncAlt } from 'react-icons/fa';

const Actuals = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [actualTotal, setActualTotal] = useState('');
    const [pocTotal, setPocTotal] = useState('');
    const [searchProjectType, setSearchProjectType] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [selectedExcelFile, setSelectedExcelFile] = useState();

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);
    const [isReplaceConfirmationModalOpen, setIsReplaceConfirmationModalOpen] = useState(false);

    const [type, setType] = useState('Add');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [projectTypeID, setProjectTypeID] = useState();
    const [globalFilter, setGlobalFilter] = useState(null);
    // ---------------------------------------
    const [excelFile, setExcelFile] = useState(null);
    const [typeError, setTypeError] = useState(null);
    // ---------------------------------------
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [isRelplace, setIsRelplace] = useState('N');
    const [isRelplaceMessage, setIsRelplaceMessage] = useState("null");
    const [isFormSubmitLoadder, setIsFormSubmitLoadder] = useState(false);
    const [poc, setPoc] = useState(0);
    const [others, setOthers] = useState(0);
    // ---------------------------------------
    const [selectedYearForEdit, setSelectedYearForEdit] = useState(null);
    const [selectedMonthForEdit, setSelectedMonthForEdit] = useState(null);
    // ---------------------------------------
    const years = [
        { year: '2020', },
        { year: '2021', },
        { year: '2022', },
        { year: '2023', },
        { year: '2024', },
        { year: '2025', },
        { year: '2026', },
        { year: '2027', },
        { year: '2028', },
        { year: '2029', },
        { year: '2030', },
    ];
    const months = [
        { month: 'Jan' },
        { month: 'Feb' },
        { month: 'Mar' },
        { month: 'Apr' },
        { month: 'May' },
        { month: 'Jun' },
        { month: 'Jul' },
        { month: 'Aug' },
        { month: 'Sep' },
        { month: 'Oct' },
        { month: 'Nov' },
        { month: 'Dec' },
    ]
    // ---------------------------------------
    const openModal = () => {
        setProjectTypeID('');
        setType('Add');
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
        setIsReplaceConfirmationModalOpen(false);
    };

    useEffect(() => {
        // console.log('Fetching projects...xlxl');
        getProjectType();
    }, []);

    const getProjectType = (project) => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'get-all-excel-actual-pm',{headers})
            .then((response) => {
                var data = response.data.result;
                setActualTotal(response.data.totalActual.total);
                setPocTotal(response.data.totalActual.pocTotal);
                setProjectType(data);
                setSearchProjectType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
    };

    const confirmDelete = async () => {
        axios.get(Api.API_BASE_URL + 'delete-project-type/' + projectTypeID)
            .then((response) => {
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data.result, life: 3000 });
                getProjectType();
                closeModal();
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    // -------------------------------------
    const handleFile = (e) => {
        let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        let selectedFile = e.target.files[0];
        setSelectedExcelFile(selectedFile)
        if (selectedFile) {
            if (selectedFile && fileTypes.includes(selectedFile.type)) {
                setTypeError(null);
                let reader = new FileReader();
                reader.readAsArrayBuffer(selectedFile);
                reader.onload = (e) => {
                    setExcelFile(e.target.result);
                }
            }
            else {
                setTypeError('Please select only excel file types');
                setExcelFile(null);
            }
        }
        else {
            console.log('Please select your file');
        }
    }



    const handleFileSubmit = async (e) => {
        e.preventDefault();

        if (excelFile !== null) {
            setIsFormSubmitLoadder(true)
            
            const formData = new FormData();
            console.log("isRelplaceMessage:", selectedYear.year);
            var year = selectedYear.year;
            var month = selectedMonth.month;
            formData.append("year", year);
            formData.append("month", month);
            formData.append("isRelplace", isRelplace);
            formData.append("excel_file", selectedExcelFile);
            formData.append("poc", poc);
            formData.append("others", others);
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
              
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(Api.API_BASE_URL + 'excel-upload-actual-pm', {
                method: "POST",
                headers:headers,
                body: formData,
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setIsFormSubmitLoadder(false)
                    if (Josn.error !== '') {
                        if (Josn.isRelplace === "Y") {
                            closeModal();
                            setIsRelplaceMessage(Josn.error.toString());

                            setIsReplaceConfirmationModalOpen(true)

                            setIsRelplace(Josn.isRelplace)
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                        }
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        setSelectedYear(null);
                        setSelectedMonth(null);
                        setPoc();
                        setOthers();
                        setExcelFile(null);
                        closeModal();
                        getProjectType();
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    };


    const [serVal, setserVal] = useState('');
  

    const getActualByYearAndMonth = () => {
        if (selectedYearForEdit && selectedMonthForEdit) {
            setIsLoading(true);
    
            var _body = {
                year: selectedYearForEdit.year,
                month: selectedMonthForEdit.month
            }

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
               'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(Api.API_BASE_URL + 'get-all-excel-actual-pm-all', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(_body),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setIsFormSubmitLoadder(false)
                    if (Josn.error !== '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                        setIsLoading(false);
                    } else {
                        console.log(Josn.result);
                        setProjectType(Josn.result);
                        setActualTotal(Josn.totalActual.total);
                        setPocTotal(Josn.totalActual.pocTotal);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error("Error:", error);
                });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select Year and Month' });
        }
    }
    // -------------------------------------
    const balanceTemplate = (rowData) => {
        if (rowData === '') {
            return '';
        }
        if (typeof rowData == 'string') {
            rowData = parseInt(rowData);
        }
        if (rowData == 0) {
            return '';
        }
        return <span className="font-bold">{formatCurrency(rowData)}</span>;
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    // -------------------------------------
    const refreshData = () => {
        getProjectType();
        setSelectedYearForEdit(null);
        setSelectedMonthForEdit(null);
      
    };
    // -------------------------------------
    /** //*---- Excel file Download start  */
    const exportExcel = () => {
        const modifiedProducts = projectType.map(product => ({
            'Year': product.year,
            'Month': product.month,
            "QB Project Name": product.qb_project_name,
            "Project Name": product.project_name,
            "Actual PM": product.actuals_pm,
            "POC": product.poc,
            "Status": product.status,
        }));
        import('xlsx').then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(modifiedProducts);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, 'active_leads_');
        });
    };
    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };
    /** //!---- Excel file Download end */


    const header = (
        <div className="flex flex-wrap align-items-end justify-content-between p-2 ">
            <div className='flex flex-wrap    gap-4'>
                <Dropdown
                    value={selectedYearForEdit}
                    options={years}
                    optionLabel="year"
                    onChange={(e) => setSelectedYearForEdit(e.value)}
                    placeholder="Select a Year"
                    className="w-full md:w-14rem p-2"
                />

                <Dropdown
                    value={selectedMonthForEdit}
                    options={months}
                    optionLabel="month"
                    onChange={(e) => setSelectedMonthForEdit(e.value)}
                    placeholder="Select a Month"
                    className="w-full md:w-14rem p-2"
                />

                <Button className='p-2 customSave-button' title='Submit' onClick={getActualByYearAndMonth}>Submit</Button>
                <Button className='p-2 copySave-button' title='Refresh' onClick={refreshData}><FaSyncAlt /></Button>
                <Button className='p-2 customSave-button'  title='Download in xlsx Formate' icon="pi pi-file-excel" onClick={exportExcel}></Button>
            </div>

            <div className="flex flex-wrap gap-4">
                <span className="p-input-icon-left  p-2 ">
                    Actuals Pm Total: {balanceTemplate(actualTotal)}
                </span><span className="p-input-icon-left  p-2 ">
                    POC Total: {balanceTemplate(pocTotal)}
                </span>
            </div>
        </div>
    );

    // -------------------------------------

    return (
        <>
            {/* // -------------------------------------------------------------------------------------- */}
            <div style={{ textAlign: "end", padding: "10px", paddingBottom:'0px' }}>
                <button type="button" title='Add a new file' className="custom-button" onClick={openModal} >
                    + ADD
                </button>
            </div>
            {/* ----------------------------------------------------------------------------------------  */}

            <div className="pagee-container">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        
                        <DataTable key={projectType} value={projectType} align="center" paginator rows={12} dataKey="id" selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)} scrollHeight="flex" tableStyle={{ minWidth: '50rem' }} selectionMode="single" header={header} globalFilter={globalFilter} >
                            <Column field="year" header="YEAR " bodyClassName="ActPad"></Column>
                            <Column field="month" header="MONTH " ></Column>
                            <Column field="qb_project_name" header="QB PROJECT NAME " style={{ minWidth: '150px', }} ></Column>
                            <Column field="project_name" header="PROJECT NAME " style={{ minWidth: '150px', textAlign: 'center' }} ></Column>
                            <Column
                                field="actuals_pm"
                                header="ACTUALS PM "
                                style={{ minWidth: '150px', textAlign: 'center', fontWeight: 'bold' }}
                               
                                body={(rowData) => (
                                    <span style={{ color: rowData.actuals_pm < 0 ? 'red' : 'inherit' }}>
                                     
                                        {rowData.actuals_pm < 0 ? `- $${Math.abs(rowData.actuals_pm)}` : `$${rowData.actuals_pm}`}
                                    </span>
                                )}
                            >

                            </Column>
                            <Column
                                field="poc"
                                header="POC "
                                style={{ minWidth: '150px', textAlign: 'center', fontWeight: 'bold' }}
                                body={(rowData) => (
                                    <span style={{ color: rowData.poc < 0 ? 'red' : 'inherit' }}>
                                        {rowData.poc < 0 ? `- $${Math.abs(rowData.poc)}` : `$${rowData.poc}`}
                                    </span>
                                )}
                            >
                            </Column>

                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}
            <Dialog header="" visible={isModalOpen} maximizable style={{ width: '50vw' }} onHide={() => setIsModalOpen(false)}>

                <div className=''>
                    <form onSubmit={handleFileSubmit} >
                        <div className="formmm">
                            <div className="row">
                                <Dropdown
                                    value={selectedYear}
                                    onChange={(e) => { console.log(e.value); setSelectedYear(e.value) }}
                                    options={years}
                                    optionLabel="year"
                                    editable
                                    required
                                    placeholder="Select a Year"
                                    className="w-full dropdown-padding"
                                    virtualScrollerOptions={{ itemSize: 28 }}
                                />

                                <Dropdown
                                    value={selectedMonth}
                                    onChange={(e) => { console.log(e.value); setSelectedMonth(e.value) }}
                                    options={months}
                                    optionLabel="month"
                                    editable
                                    required
                                    placeholder="Select a Month"
                                    className="w-full dropdown-padding"
                                    virtualScrollerOptions={{ itemSize: 28 }}
                                />
                            </div>
                        </div>


                        <div className="flex-col px-3">
                        
                            <input type="file" className='uploadfile w-full' required onChange={handleFile} />
                            <div  className="w-full flex mt-5" style={{justifyContent:'center'}}>
                                {isFormSubmitLoadder ? (
                                    <button type='button' className='customSave-button' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
                                ) : (<button type='submit' className='customSave-button' > SUBMIT </button>)}
                            </div>
                        </div>
                    </form>
                    {typeError && (
                        <div style={{ color: "red", display: "block", textAlign: 'center', fontSize: '2rem', fontWeight: 'bold' }}>
                            {typeError}
                        </div>
                    )}
                </div>

            </Dialog>

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this project? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isReplaceConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>{isRelplaceMessage}</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                No
                            </button>
                            {isFormSubmitLoadder ? (
                                <button className='delete-buttonx' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
                            ) : (<button className="delete-buttonx" onClick={handleFileSubmit}>
                                Yes
                            </button>)}

                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Actuals